import { Directive, Input, HostListener, inject, ViewContainerRef } from '@angular/core';
import { ModalService, ModalConfig, ModalButton } from '../index';

@Directive({
  selector: '[appModalTrigger]',
  standalone: true
})
export class ModalTriggerDirective {
  @Input('appModalTrigger') modalConfig!: ModalConfig;
  @Input() modalData?: any;
  @Input() modalSize: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input() modalTitle?: string;
  @Input() modalContent?: string;
  @Input() modalButtons?: ModalButton[];
  @Input() confirmModal = false;
  @Input() alertModal = false;
  @Input() confirmText = 'Confirmar';
  @Input() cancelText = 'Cancelar';
  @Input() alertButtonText = 'Aceptar';

  private modalService = inject(ModalService);
  private viewContainerRef = inject(ViewContainerRef);

  constructor() {
    this.modalService.setViewContainerRef(this.viewContainerRef);
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.preventDefault();
    this.openModal();
  }

  private openModal() {
    if (this.confirmModal) {
      this.openConfirmModal();
    } else if (this.alertModal) {
      this.openAlertModal();
    } else {
      this.openCustomModal();
    }
  }

  private openConfirmModal() {
    const title = this.modalTitle || 'Confirmar';
    const content = this.modalContent || '¿Estás seguro?';

    this.modalService.confirm(
      title,
      content,
      this.confirmText,
      this.cancelText
    ).subscribe(confirmed => {
      if (confirmed) {
        this.dispatchCustomEvent('modalConfirmed', { confirmed: true, data: this.modalData });
      } else {
        this.dispatchCustomEvent('modalCancelled', { confirmed: false, data: this.modalData });
      }
    });
  }

  private openAlertModal() {
    const title = this.modalTitle || 'Información';
    const content = this.modalContent || 'Información importante';

    this.modalService.alert(
      title,
      content,
      this.alertButtonText
    ).subscribe(() => {
      this.dispatchCustomEvent('modalClosed', { data: this.modalData });
    });
  }

  private openCustomModal() {
    const config: ModalConfig = this.modalConfig || {
      title: this.modalTitle || 'Modal',
      content: this.modalContent,
      size: this.modalSize,
      buttons: this.modalButtons
    };

    const modalRef = this.modalService.open(config, this.modalData);
    modalRef.afterClosed().subscribe(result => {
      this.dispatchCustomEvent('modalResult', { result, data: this.modalData });
    });
  }

  private dispatchCustomEvent(eventName: string, detail: any) {
    const event = new CustomEvent(eventName, {
      detail,
      bubbles: true,
      cancelable: true
    });

    // Dispatch en el elemento host
    if (this.viewContainerRef.element.nativeElement) {
      this.viewContainerRef.element.nativeElement.dispatchEvent(event);
    }
  }
}
